module.exports = __webpack_public_path__ + "static/media/applehealth.e006fc9d.png";